module.exports = __webpack_public_path__ + "static/media/lock.e6c53de1.svg";